import React from "react";
import {Box, SkipNavContent, View} from "@unibuddy/patron";

const AUTH_PAGE_WIDTH = "414px";

export function AuthPageContainer({children}) {
    return (
        <Box display="flex" justifyContent="center" width="100%">
            <SkipNavContent />
            <View
                maxW={AUTH_PAGE_WIDTH}
                width="100%"
                gap="large"
                borderWidth={1}
                borderColor="grey150"
                borderRadius="xsmall"
                padding="small-medium"
            >
                {children}
            </View>
        </Box>
    );
}
